import { useGetProductFullView, useGlobalModal } from 'hooks';
import { useSelector } from 'react-redux';

import PublicationSetupModal from '../publication-setup-modal/PublicationSetupModal';
import { useEffect, useState } from 'react';
import PublicationValidationView from '../publication-validation-view/PublicationValidationView';
import PostToModal from '../post-to-walmart-krogger/PostToModal';
import selectorsGridView from 'common/components/grid-view/controllers/selectors';

const PublicationProduct = (props) => {
  const { isFullView, productId = null } = props;

  const [requestParams, setRequestParams] = useState(null);
  const [validRetailers, setValidRetailers] = useState({});
  const [isPostToModalOpen, setIsPostToModalOpen] = useState(false);

  const selectProductGrid = useSelector(
    selectorsGridView.makeSelectDetailCurrentITemsSelection()
  );

  const { MODAL_NAMES, checkModalVisible, closeModal, openModal } =
    useGlobalModal();

  const isPublicationSetupModalOpen = checkModalVisible(
    MODAL_NAMES.PUBLICATION_SETUP_MODAL
  );

  const isPublicationValidateViewModalOpen = checkModalVisible(
    MODAL_NAMES.PUBLICATION_VALIDATE_VIEW_MODAL
  );

  const { productFull } = useGetProductFullView({ productId });

  const selectedProducts = isFullView ? [productFull] : selectProductGrid;

  const togglePostToModal = () => {
    setIsPostToModalOpen((prev) => !prev);
  };

  const handleUpdateValidRetailers = (recipientRetailerValidation) => {
    setValidRetailers((prev) => ({
      ...prev,
      ...recipientRetailerValidation,
    }));
  };

  const resetState = () => {
    setRequestParams(null);
    setValidRetailers({});
  };

  useEffect(() => {
    if (!isPublicationSetupModalOpen) {
      resetState();
    }
  }, [isPublicationSetupModalOpen]);

  return (
    <>
      {isPublicationSetupModalOpen && (
        <PublicationSetupModal
          visible={isPublicationSetupModalOpen}
          handleCancel={() => {
            setRequestParams([]);
            closeModal(MODAL_NAMES.PUBLICATION_SETUP_MODAL);
          }}
          handleOk={(values) => {
            setRequestParams(values);
            openModal(MODAL_NAMES.PUBLICATION_VALIDATE_VIEW_MODAL);
          }}
          isFullView={isFullView}
          productId={productId}
          handleUpdateValidRetailers={handleUpdateValidRetailers}
        />
      )}

      {isPublicationValidateViewModalOpen && (
        <PublicationValidationView
          visible={isPublicationValidateViewModalOpen}
          requestParams={requestParams}
          isFullView={isFullView}
          productId={productId}
          validRetailers={validRetailers}
          togglePostToModal={togglePostToModal}
        />
      )}

      <PostToModal
        togglePostToModal={togglePostToModal}
        isPostToModalOpen={isPostToModalOpen}
        selectedProducts={selectedProducts}
        isFullView={isFullView}
      />
    </>
  );
};

export default PublicationProduct;
